<template>
  <div class="product-info">
    <topNav tit="参数介绍"></topNav>
    <div class="top clearfix" v-if="topData.imgUrl !== ''">
      <img :src="topData.imgUrl | urlProtocol" alt="">
      <div class="top-info">
        <h2>{{topData.desc}}</h2>
        <p :class="{'off': !(topData.sale > 0)}">价格详询门店导购</p>
        <span v-if="topData.sale > 0">已售：{{topData.sale}}</span>
      </div>

    </div>
    <div class="detail" v-if="infoData !== ''">
      <div class="drop" @click="dropInfo" :class="{'off': !dropSw}">商品参数</div>
      <div class="drop-wrap" v-for="(item,value) in infoData" v-if="dropSw">
        <div class="title">{{value}}</div>
        <ul>
          <li v-for="subItem in item">
            <div class="label">{{subItem.parameterDesc}}:</div>
            <div class="param">{{subItem.parameterVal}}</div>
          </li>
        </ul>
      </div>
    </div>
    <div class="bottom" @click="skipGuide" name="o2o_canshuye_daogou_01">预约导购</div>
    <input type="hidden" id="pagename" value="pgcate=10009;tag=100043;pgtitle=身边苏宁-商品参数页">
  </div>
</template>

<script>
  import CONF from '@/app.conf.json'
  import Server from '@/services/Entrance'
  import topNav from '@/components/commons/_topNav'
  import {Util} from '../commons/util'
  import _ from "lodash"

  export default{
  	name:'ProductInfo',
    data(){
  		return {
  			prdCode:'',
        cityCode:'025',
  			topData: {
  				imgUrl: '',
          desc: '',
          sale: ''
        },
        infoData: '',
        dropSw: true
      }
    },
    components: {
    	topNav
    },
    mounted() {

      document.title="参数介绍";

      //顶部信息
      let storage = Util.getLocalStorage(),
          topData = this.topData,
          prdCode = this.prdCode = this.$route.params.prdCode;
      topData.imgUrl = storage.getItem('prdUrl');
      topData.desc = storage.getItem('prdDesc');
      topData.sale = storage.getItem('prdSale');
      this.cityCode = storage.getItem('cityCode');
      this.topData = topData;


      Server.productinfo.queryProductInfo(prdCode).then(data => {
      	console.log(data.data)
        if(data.data.hasOwnProperty('parameter')){
          let paramData = data.data.parameter;
          if(paramData.errCode === '0' && paramData.parametersList.length > 0){
            this.infoData = _.groupBy(paramData.parametersList,'parametersDesc');
            console.log(this.infoData)
          }
        }
      })
    },
    methods: {
      dropInfo(){
      	this.dropSw = !this.dropSw
      },
      skipGuide(){
        window.location.href = CONF.otherPage.orderPage.replace('{{cityId}}', this.cityCode);
      }
    }
  }

</script>

<style scoped="">
  .sn-nav-back{
    margin: 0;
  }
  .product-info{
    font-size: 26px;
    color: #222222;
  }
  .product-info,.top,.drop{
    background: #ffffff;
  }
  .top{
    padding: 30px 0;
    margin: 0 25px;
    border-bottom: dashed 1px #999999;
    img{
      float: left;
      /*border: 1px solid;*/
      width: 200px;
      height: 200px;
    }
    .top-info{
      float: left;
      width: 470px;
      margin: 0 0 0 25px;
    }
    h2{
      font-size: 28px;
      margin: 5px 0 20px 0;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
    }
    p{
      margin: 0 0 45px 0;
      display: inline-block;
      position: relative;
      font-size: 24px;
      color: #999999;
      &:before{
        content: '';
        display: block;
        position: absolute;
        top: 5px;
        right: -90px;
        width: 82px;
        height: 26px;
        background: url("../assets/sales.png") no-repeat center;
        background-size: 82px 26px;
       }
    }
    .off:before{
      content: '';
      display: none;
    }
    span{
      display: block;
      font-size: 22px;
      color: #999999;
    }
  }
  .detail{
    margin: 0 0 100px 0;
    background: #fafafa;
    .drop{
      position: relative;
      font-size: 30px;
      line-height: 36px;
      padding: 30px 25px;
      &:before{
         content: "";
         position: absolute;
         top: .8rem;
         right: .7rem;
         display: inline-block;
         width: .48rem;
         height: .48rem;
         border: solid #222222;
         border-width: 1px 0 0 1px;
         -webkit-transform: rotate(45deg);
       }
    }
    .drop.off:before{
      content: '';
      top: .4rem;
      -webkit-transform: rotate(-135deg);
    }
  }
  .drop-wrap{
    margin: 20px 40px;
    background: #fafafa;
    border-bottom: dashed 1px #999999;
    .title{
      position: relative;
      line-height: 50px;
      margin: 0 0 18px 0;
      &:before{
        content: '';
        display: block;
        position: absolute;
        top: 16px;
        left: -16px;
        width: 8px;
        height: 22px;
        background: #ffda33;
       }
    }
    ul{

    }
    li{
      overflow: hidden;
    }
    .label,.param{
      float: left;
      line-height: 36px;
      margin: 0 0 18px 0;
    }
    .label{
      width: 180px;
      color: #999999;
    }
    .param{
      width: 480px;
      text-align: left;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .bottom{
    position: fixed;
    bottom: 0;
    left:0;
    width: 100%;
    font-size: 32px;
    height: 80px;
    line-height: 80px;
    color: #ffffff;
    text-align: center;
    background: #ff9900;
  }
</style>



// WEBPACK FOOTER //
// src/components/ProductInfo.vue